export default {
      id: "live-filter-yellow-usage",
      viewBox: "0 0 22 21",
      url: "/" + "images/icons.3.109.2.svg#live-filter-yellow-usage",
      toString: function () {
        return this.url;
      }
    }